class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );

      this.input.form.addEventListener('submit', this.onSubmit.bind(this));
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  isLikelySku(value) {
    if (!value) return false;
    const normalized = value.trim();
    return /^[A-Za-z0-9._\- ]+$/.test(normalized);
  }

  buildSkuQuery(value) {
    const normalized = value.trim().replace(/\s+/g, ' ');
    const escaped = normalized.replace(/"/g, '\\"');

    return `variants.sku:"${escaped}" OR variants.sku:${escaped}*`;
  }

  onSubmit() {
    if (!this.input) return;

    const raw = this.input.value.trim();
    if (!raw) return;

    if (!this.isLikelySku(raw)) return;

    this.input.value = this.buildSkuQuery(raw);
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);